
import {
  computed,
  useContext,
  useMeta,
  defineComponent,
} from '@nuxtjs/composition-api';
import { useDomain } from '~/composables';

interface Props {
  items: {
    text?: string;
    textKey?: string;
    link?: string;
    hidden?: boolean;
  }[];
  overridePredefined?: boolean;
}

export default defineComponent({
  props: {
    items: {
      type: Array as () => Props['items'],
      required: true,
    },
    overridePredefined: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const { i18n, app } = useContext();
    const { domain } = useDomain();

    const predefinedCrumbs = {
      main: { textKey: 'home_page', link: '/' },
    };

    const crumbs = computed(() => {
      return (
        props.overridePredefined
          ? [...props.items]
          : [{ ...predefinedCrumbs.main }, ...props.items]
      ).filter(({ hidden }) => !hidden);
    });

    const breadcrumbJsonLd = computed(() => {
      const items = crumbs.value.map((item, index) => {
        const base = {
          '@type': 'ListItem',
          position: index + 1,
          name: item.text || (i18n.t(item.textKey || '') as string),
        };

        if (item.link) {
          const path = app.localePath(item.link);
          return {
            ...base,
            item: `https://${domain}${path}`,
          };
        }

        return base;
      });

      return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items,
      };
    });

    useMeta(() => ({
      script: [
        {
          type: 'application/ld+json',
          json: breadcrumbJsonLd.value,
        },
      ],
    }));

    return {
      crumbs,
    };
  },
  head: {},
});
